<ng-template #selectedDate let-type="type" let-text="text" let-date="date">
  <div class="flex tr-xsmall pr-medium-l" [attr.data-testid]="'matrix-date-' + type">
    <fcom-icon class="icon-medium flex--nogrow ms-xxsmall-r" [name]="type" />
    <div class="flex flex--column flex--align-start">
      <span class="dn-mobile">{{ text | finLocalization }}</span>
      <div class="medium-type">{{ date | finDateFormat: 'FULL_NO_YEAR' }}</div>
    </div>
  </div>
</ng-template>

<fcom-modal
  data-testid="aircalendar-modal-overlay"
  [(open)]="airCalendarOpen"
  [title]="'airCalendar.flexibleTravelDates' | finLocalization"
  [fitToContent]="true"
  [fullHeight]="true"
  [extraWide]="true"
  [buttons]="ModalButtons.CUSTOM"
  (close)="closeAirCalendar()"
>
  @if (airCalendarOpen() && isAward()) {
    <div class="flex flex--center">
      <fcom-notification
        [theme]="NotificationTheme.TRANSPARENT"
        class="block"
        [attr.data-testid]="'notification-points'"
      >
        {{
          'award.notifications.totalPointsV2' | finLocalization: { points: totalPoints() | finPoints | finEmpty: '-' }
        }}
      </fcom-notification>
    </div>
  }

  @if (airCalendarOpen()) {
    <fin-price-matrix
      [calendarList]="prices()"
      [isAward]="isAward()"
      [preselectedDeparture]="preselectedDeparture()"
      [preselectedReturn]="preselectedReturn()"
      (selectedDates)="selectCalendarDates($event)"
    />
  }

  <div
    buttons
    class="airCalendarFooter df-tablet-up flex--middle flex--space-between align-left font-body-medium"
    data-testid="price-matrix-footer"
  >
    <div class="price-and-date-container flex">
      <div class="flex flex--column flex--align-start starting-price-container">
        <div data-testid="matrix-starting-price">
          {{ 'priceCalendar.pricesFrom' | finLocalization }}
          @if (!isAward()) {
            <span class="medium-type"
              >&nbsp;{{ startingPrice() | finPrice: { roundPrice: true } | finEmpty: '&ndash;' }}</span
            >
          }
          @if (isAward()) {
            <span class="medium-type"
              >&nbsp;{{
                'award.points' | finLocalization: { pointsAmount: startingPrice() | finMap: 'amount' | finPoints }
              }}</span
            >
          }
        </div>
        <div data-testid="pax-amount-breakdown">{{ paxAmountBreakdown() }}</div>
      </div>
      <div class="dates df-tablet-up flex-1">
        <ng-container
          [ngTemplateOutlet]="selectedDate"
          [ngTemplateOutletContext]="{
            type: 'departure',
            text: 'departure',
            date: travelDates()?.departureDate,
          }"
        />
        @if (tripType() !== TripType.ONEWAY) {
          <ng-container
            [ngTemplateOutlet]="selectedDate"
            [ngTemplateOutletContext]="{
              type: 'arrival',
              text: 'returnDate',
              date: travelDates()?.returnDate,
            }"
          />
        }
      </div>
    </div>
    <div class="align-center">
      <fcom-button
        class="continue-btn"
        [theme]="ButtonTheme.PRIMARY_ACCENT"
        [size]="ButtonSize.LARGE"
        [text]="'bookingSearch.search' | finLocalization"
        [disabled]="continueDisabled()"
        (clickBtn)="navigateToBookingFlow()"
        data-testid="aircalendar-continue-button"
      />
    </div>
  </div>
</fcom-modal>
